import App from '@/models/App'

export default class Restrict extends App {
    static get entity() {
        return 'restricts'
    }
    static one() {
        return this.query().first()
    }
    static fields() {
        return {
            id: this.attr(''),
            userId: this.attr(''),
            limitStorage: this.attr(''),
            limitContacts: this.attr(0),
            limitShips: this.attr(0),
            usedStorages: this.attr(0),
            usedContacts: this.attr(0),
            usedShips: this.attr(0),
            isShipCreate: this.attr(false),
        }
    }
}
